<template>
  <div style="background: #f0f2f5;">
    <nav-bar />
    <div class="inner-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar";
export default {
  name: "HeaderLayout",
  components: {
    NavBar,
  },
}
</script>

<style scoped>
.inner-container{
  width: 80%;
  min-height: calc(100vh - 65px);
  margin: 0 auto;
}
</style>